import { IMaladie } from './../../views/agenda/interface/imaladie';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import { AppGlobals } from '../../app.globals';
import { map } from 'rxjs/operators';


import { AgendaGap } from './agenda-gap';
import { Agenda } from './agenda';
import { Jour } from './jour';
import { Semaine } from './semaine';
import { Prestation } from './prestation';
import * as moment from 'moment'
import { CodePrestation } from './../codes/code-prestation';

@Injectable()
export class AgendaService {

    public newAgendaPrestationSorted: Prestation[] = [];
    private _url: string = '/api/Agenda/';

    constructor(private http: HttpClient, private authService: AuthService) { }

    getAgendaSecretariat(clePerso: number, periode: string, forceInjection: boolean): Observable<Agenda> {
        let dateDebut = moment(periode + '/01', "MM/YYYY/DD");
        let dateFin = moment(dateDebut).add(1, 'month').add(-1, 'days');
        let searchParams = `?datedebut=${moment(dateDebut).format('YYYYMMDD')}&datefin=${moment(dateFin).format('YYYYMMDD')}`;
        if (forceInjection == true)
            searchParams += `&forceinjection=1`;
        else
            searchParams += `&forceinjection=0`;

        return this.http.get<any>(`${this._url}GetAgendaSecParPersonnel/${clePerso}${searchParams}`)
            .pipe(map(agendaGap => {
                var agenda: Agenda = new Agenda([]);
                let semaine = 0;
                var index = -1;
                var dDate = dateDebut;
                var duree: number[] = [];
                var weeksIndex: number[] = [];
                while (dDate <= dateFin) {
                    if (semaine != dDate.isoWeek()) {
                        agenda.Semaines.push(new Semaine());
                        semaine = dDate.isoWeek();
                        weeksIndex.push(semaine);
                        index++;
                    }
                    let day = dDate.isoWeekday() - 1;
                    agenda.Semaines[index].Jours[day].Day = dDate.date();
                    agenda.Semaines[index].Jours[day].Date = dDate.toDate();
                    duree.push(0);

                    dDate = moment(dDate).add(1, 'days');

                }
                for (let rdv of agendaGap.AgendaHeure) {
                    let day = moment(rdv.Date).isoWeekday() - 1;
                    let week = weeksIndex.indexOf(moment(rdv.Date).isoWeek());
                    let monthDay = moment(rdv.Date).date() - 1;
                    let presta = new Prestation(rdv.Cle, rdv.ClePeriodeOccupation, rdv.CleCodePrestation, rdv.CodePrestationCode, rdv.Date, rdv.Debut, rdv.Duree, rdv.Repos, rdv.Quantite, rdv.MontantPaie, rdv.CodePrestationTypeHeureJour, rdv.CodePrestationSigne, rdv.MemoRemarque, rdv.CodePrestationEncodageHeure, rdv.CodePrestationCleUnite);
                    agenda.Semaines[week].Jours[day].Prestations.push(presta);
                    duree[monthDay] = duree[monthDay] + rdv.CodePrestationSigne * AppGlobals.heureToMin(rdv.Duree);
                    agenda.Semaines[week].Jours[day].DureeJour = duree[monthDay];
                }


                for (let rdv of agendaGap.AgendaValeur) {
                    let day = moment(rdv.Date).isoWeekday() - 1;
                    let week = weeksIndex.indexOf(moment(rdv.Date).isoWeek());
                    let presta = new Prestation(rdv.Cle, rdv.ClePeriodeOccupation, rdv.CleCodePrestation, rdv.CodePrestationCode, rdv.Date, rdv.Debut, rdv.Duree, rdv.Repos, rdv.Quantite, rdv.MontantPaie, rdv.CodePrestationTypeHeureJour, rdv.CodePrestationSigne, rdv.MemoRemarque, rdv.CodePrestationEncodageHeure, rdv.CodePrestationCleUnite);
                    agenda.Semaines[week].Jours[day].Prestations.push(presta);
                }



                for (let horTheo of agendaGap.HoraireTheo) {
                    let day = moment(horTheo.Date).isoWeekday() - 1;
                    let week = weeksIndex.indexOf(moment(horTheo.Date).isoWeek());

                    agenda.Semaines[week].Jours[day].DureeJourTheo = horTheo.Duree;
                }

                for (let pointage of agendaGap.Pointages) {
                    let day = moment(pointage.Date).isoWeekday() - 1;
                    let week = weeksIndex.indexOf(moment(pointage.Date).isoWeek());

                    agenda.Semaines[week].Jours[day].AvecPointage = true;
                }

                for (let maladie of agendaGap.MaladiesAccidents) {
                    let dateDebutMaladie = moment(maladie.Debut).toDate(); //20220502
                    let dateFinMaladie = moment(maladie.Fin).toDate();
                    //20220504

                    while (dateDebutMaladie <= dateFinMaladie) {

                        if (dateDebutMaladie >= dateDebut.toDate() && dateDebutMaladie <= dateFin.toDate()) {

                            let day = moment(dateDebutMaladie).isoWeekday() - 1;
                            let week = weeksIndex.indexOf(moment(dateDebutMaladie).isoWeek());

                            agenda.Semaines[week].Jours[day].AvecMaladie = true;
                            agenda.Semaines[week].Jours[day].CleMaladie = maladie.Cle;
                        }
                        dateDebutMaladie = moment(dateDebutMaladie).add(1, 'days').toDate();
                    }
                }

                agenda.codesPrestation = agendaGap.CodesPrestation.map((item) => new CodePrestation(item.Cle, item.Code, item.Libelle));

                return agenda;
            }));


    }

    setAgendaHeure(agenda: Prestation, remplace: boolean): Observable<Prestation> {
        let body = {
            Date: moment(agenda.Date).format('YYYYMMDD'),
            Debut: agenda.Debut,
            Duree: agenda.DureeQte,
            Repos: agenda.Repos,
            CleCodePrestation: agenda.CleCodePrestation,
            ClePeriodeOccupation: agenda.ClePeriodeOccupation,
            MemoRemarque: agenda.MemoRemarque,
            Remplace: remplace
        };
        if (agenda.Cle > 0) {
            return this.http.put<any>(this._url + 'AgendaHeure/' + agenda.Cle, body).pipe(map(
                resp => {
                    return resp;
                }));
        } else {
            return this.http.post<any>(this._url + 'AgendaHeure/', body).pipe(map(
                resp => {
                    return resp;
                }));
        }
    }

    deleteAgendaHeure(cle: number): Observable<any> {
        if (cle > 0) {
            return this.http.delete<any>(this._url + 'AgendaHeure/' + cle).pipe(map(
                resp => {
                    return resp;
                }));
        }
    }

    modifAgendaHeureParPeriode(data: any): Observable<any> {
        return this.http.post<any>(this._url + 'ModifAgendaHeureParPeriode', data).pipe(map(
            resp => {
                return resp;
            }));
    }

    modifAgendaValeurParPeriode(data: any): Observable<any> {
        return this.http.post<any>(this._url + 'ModifAgendaHeureParPeriode', data).pipe(map(
            resp => {
                return resp;
            }));
    }

    setAgendaValeur(agenda: Prestation, remplace: boolean): Observable<Prestation> {
        let body = {
            Date: moment(agenda.Date).format('YYYYMMDD'),
            Quantite: agenda.Quantite,
            MontantPaie: agenda.MontantPaie,
            CleCodePrestation: agenda.CleCodePrestation,
            ClePeriodeOccupation: agenda.ClePeriodeOccupation,
            Remplace: remplace
        };
        if (agenda.Cle > 0) {
            return this.http.put<any>(this._url + 'AgendaValeur/' + agenda.Cle, body).pipe(map(
                resp => {
                    return resp;
                }))
                ;
        } else {
            return this.http.post<any>(this._url + 'AgendaValeur/', body).pipe(map(
                resp => {
                    return resp;
                }));
        }
    }

    deleteAgendaValeur(cle: number): Observable<any> {
        if (cle > 0) {
            return this.http.delete<any>(this._url + 'AgendaValeur/' + cle).pipe(map(
                resp => {
                    return resp;
                }));
        }
    }

    sortingAgendaPrestations(agendaPrestations: Prestation[]) {

        if (agendaPrestations.length >= 2) {
            agendaPrestations.sort(function (a, b) {
                let x = a.Debut ? a.Debut : '';
                let y = b.Debut ? b.Debut : '';
                if (x == '' && y == '') {
                  x = a.CodePrestationCode;
                  y = b.CodePrestationCode;
                }
                return x > y ? 1 : x < y ? -1 : 0;
            });
        }
        return agendaPrestations;
    }

}
